import { useState } from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { useTranslation } from 'react-i18next';

import Text from '../../../../../shared/Text';
import { PostList } from './PostList.jsx';

export const PostSummary = ({ posts, campaignUuid, sortByDate, sortOrder }) => {
  const { t } = useTranslation('posts');

  const [openMenu, setOpenMenu] = useState(false);
  const sortOptions = [
    { order: 'asc', title: t('postSummary.sortAsc') },
    { order: 'desc', title: t('postSummary.sortDesc') },
  ];

  return (
    <Container>
      <Header>
        <Text variant="subtitle1">
          {t('postSummary.campaignPostCount', { count: posts.length })}
        </Text>
      </Header>
      <SortContainer>
        <ListOrder onClick={() => setOpenMenu(!openMenu)}>
          <Text variant="small1">
            <Icon
              className={`fa-solid fa-arrow-${
                sortOrder.order === 'asc' ? 'up' : 'down'
              }-wide-short`}
            />
            {sortOrder.title}
          </Text>
        </ListOrder>
        {openMenu && (
          <SortMenu>
            {sortOptions.map(option => (
              <SortOption
                key={option.order}
                onClick={() => {
                  sortByDate(option);
                  setOpenMenu(!openMenu);
                }}
              >
                <IconWrapper>
                  {sortOrder.title === option.title && (
                    <i className="fa-solid fa-check"></i>
                  )}
                </IconWrapper>
                <Title variant="small1">{option.title}</Title>
              </SortOption>
            ))}
          </SortMenu>
        )}
      </SortContainer>
      <PostList campaignUuid={campaignUuid} posts={posts} />
    </Container>
  );
};

const Container = styled.div`
  background: ${themeGet('colors.white')};
  border-radius: 8px;
  padding: 20px;
`;

const SortContainer = styled.div`
  margin: 15px 0px;
  position: relative;
`;

const Header = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ListOrder = styled.div`
  width: 149px;
  height: 32px;
  background: rgba(0, 0, 0, 0.04);
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: 0.3s;
  &:hover {
    background: ${themeGet('colors.black.10')};
  }
`;

const SortMenu = styled.ul`
  position: absolute;
  left: 0px;
  top: 35px;
  background: ${themeGet('colors.white')};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const SortOption = styled.li`
  margin: 5px 0;
  height: 20px;
  padding: 10px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &:hover {
    background: ${themeGet('colors.black.10')};
  }
`;

const IconWrapper = styled.div`
  display: inline-block;
  width: 23px;
`;

const Title = styled(Text)`
  display: inline-block;
  width: 120px;
`;

const Icon = styled.i`
  display: inline-block;
  margin-right: 4px;
`;
